import home from '@/components/homeMain/home/index.vue';
import settlement from '@/router/settlement.js';
import logistics from '@/router/logistics.js';
import mdse from '@/router/mdse.js';
import members from '@/router/members.js';
import station from '@/router/station.js';
import systemmanagement from '@/router/systemmanagement.js';
import workbench from '@/router/workbench.js';
import transacts from '@/router/transacts.js';
import couponsmanagement from '@/router/couponsmanagement.js'
import newMarket from '@/router/newMarket.js';
import storeManager from '@/router/storeManager'
import custom from '@/router/custom'
import customization from './customization'

export default [{
    path: '/homeMain/workbench/workbench',
    component: home,
    children: [
        ...workbench,
        ...settlement,
        ...logistics,
        ...mdse,
        ...members,
        ...station,
        ...systemmanagement,
        ...transacts,
        ...couponsmanagement,
        ...newMarket,
        ...storeManager,
        ...custom,
        ...customization
    ]
}]


// WEBPACK FOOTER //
// ./src/router/homeMain.js